export default "__VITE_ASSET__CxPFxhrJ__"